import React, { useContext } from 'react';

import { ServerAuthProvider, OverrideContext } from './ServerAuthProvider';

type AuthProviderProps = {
  children: React.ReactNode;
};

const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  return <ServerAuthProvider children={children} />;
};

export default React.memo(AuthProvider) as typeof AuthProvider;

export const useAuthProvider = () => {
  return useContext(OverrideContext);
};
